module.exports = __webpack_public_path__ + "assets/img/paypawhyl.dbbabfa4.svg";